import React from 'react'

import {TextField} from './fields/TextField'
import {SelectField} from './fields/SelectField'
import {ToggleRep} from './fields/ToggleRep'
import {AsyncSearchField} from './fields/AsyncSearchField'
import {XpCodeSearchField} from './fields/XpCodeSearchField'
import {AddressSearchField} from './fields/AddressSearchField'
import {ToggleField} from './fields/ToggleField'
import {CheckboxField} from './fields/CheckboxField'

export function DynamicField({field, ...props}) {
  switch (field.type) {
    case 'select':
      return <SelectField field={field} {...props} />

    case 'toggle':
      return <ToggleField field={field} {...props} />

    case 'toggleRep':
      return <ToggleRep field={field} {...props} />

    case 'async-search':
      return <AsyncSearchField field={field} {...props} />

    case 'xp-code-search':
      return <XpCodeSearchField field={field} {...props} />

    case 'address-search':
      return <AddressSearchField field={field} {...props} />

    case 'checkbox':
      return <CheckboxField field={field} {...props} />

    default:
      return <TextField field={field} {...props} />
  }
}
